export const appRouteNames = {
    MAIN: '',
};